<div class="pad-10" [id]="tourId.workflows.wfrun.wfRunOverview.id">
  <ng-container *ngIf="data && data.length > 0; else noDataTemplate">
    <app-gantt-chart [data]="data" [startTime]="startTime" [endTime]="endTime"
      [qgData]="stageDetails"></app-gantt-chart>
  </ng-container>
  <ng-template #noDataTemplate>
    <div class="text-center">
      <app-no-data-available [newData]="getNoData"></app-no-data-available>
    </div>
  </ng-template>
</div>